import React, { useState } from 'react';
import { PaginatedTable, TableDataHeader, TableRow } from '@make-software/cspr-design';

import { MessageTableRow } from './message-table-row';
import { Message } from '@/entities';
import { PaginatedApiRequestState } from '@/hooks';

export interface MessageTableProps {
  dataLoader: (page: number, perPage: number) => PaginatedApiRequestState<Message>;
}

interface PaginationState {
  page: number;
  perPage: number;
}

const ITEMS_PER_PAGE = 10;

export const MessageTable: React.FC<MessageTableProps> = ({ dataLoader }) => {
  const [{ page, perPage }, setPagination] = useState<PaginationState>({
    page: 1,
    perPage: ITEMS_PER_PAGE
  });

  const { loading, response, error } = dataLoader(page, perPage);

  return (
    <PaginatedTable
      loading={loading}
      // @ts-ignore
      data={response?.data}
      // @ts-ignore
      pageCount={response?.pageCount}
      itemCount={response?.itemCount}
      error={error}

      renderDataHeaders={() => (
        <TableRow>
          <TableDataHeader>From</TableDataHeader>
          <TableDataHeader>To</TableDataHeader>
          <TableDataHeader>Encrypted Message</TableDataHeader>
          <TableDataHeader fixedWidthRem={8.25}>Time</TableDataHeader>
        </TableRow>
      )}
      renderPaginatedData={() => (response?.data || []).map((message: Message) =>
        <MessageTableRow key={message.transactionHash} message={message} />
      )}

      currentPage={page}
      setCurrentPage={(page) => setPagination({ page, perPage })}

      // @ts-ignore
      perPage={perPage}
      setPerPage={(perPage) => setPagination({ page, perPage })}
    />
  );
};
